import { render, staticRenderFns } from "./error.vue?vue&type=template&id=2903f43d&scoped=true&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"
import style0 from "./error.vue?vue&type=style&index=0&id=2903f43d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2903f43d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnLink: require('/var/www/app/components/BtnLink.vue').default})
